export interface Profile {
  icon: string
  who: string
  situation: string
  benefit: string
}

/** "C'est pour vous si…" — avatar profiles of the product (not customer reviews). */
export const profiles: Profile[] = [
  {
    icon: '🩻',
    who: 'Manipulateur en électroradiologie médicale',
    situation: 'Vous enchaînez les examens et devez juger en quelques secondes si une image est exploitable.',
    benefit: 'Des critères de qualité, des protocoles et des check-lists à portée de main.',
  },
  {
    icon: '🎓',
    who: 'Étudiant en DE MERM ou DTS IMRT',
    situation: 'Entre les stages et les partiels, l’anatomie en coupes et les séquences IRM restent floues.',
    benefit: 'Un parcours progressif, de l’anatomie aux cas pédagogiques corrigés.',
  },
  {
    icon: '🩺',
    who: 'Étudiant en médecine',
    situation: 'Vous connaissez la théorie, mais lire une radio ou un scanner avec méthode reste difficile.',
    benefit: 'Une méthode de lecture répétable et des comparaisons normal / pathologique.',
  },
  {
    icon: '🔬',
    who: 'Interne',
    situation: 'Vous devez décrire rapidement ce que vous voyez, avec la bonne terminologie.',
    benefit: 'Sémiologie, patterns et signaux d’alerte organisés visuellement.',
  },
  {
    icon: '🏥',
    who: 'Professionnel en reprise ou en changement de poste',
    situation: 'Vous changez de modalité ou de service et voulez remettre vos repères à jour.',
    benefit: 'Une référence visuelle complète pour réviser vite, modalité par modalité.',
  },
]
